(function () {
  document.documentElement.classList.remove('no-js');
  document.documentElement.classList.add('js');

  function drawer() { return document.querySelector('cart-drawer'); }
  function uv6Open() { var d = drawer(); if (!d) return; d.classList.add('animate', 'active'); document.body.classList.add('overflow-hidden'); }
  function uv6Close() { var d = drawer(); if (!d) return; d.classList.remove('active'); document.body.classList.remove('overflow-hidden'); }
  window.uv6CartOpen = uv6Open;
  window.uv6CartClose = uv6Close;
  function uv6FetchSections() { return fetch(window.uv6Routes.cart_url + '?sections=cart-drawer,cart-icon-bubble').then(function (r) { return r.json(); }); }
  function uv6RenderSections(sections, thenOpen) {
    var body = document.getElementById('CartDrawer');
    if (body && sections['cart-drawer']) {
      var doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
      var fresh = doc.getElementById('CartDrawer');
      if (fresh) body.innerHTML = fresh.innerHTML;
    }
    var bubble = document.getElementById('cart-icon-bubble');
    if (bubble && sections['cart-icon-bubble']) {
      var doc2 = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
      var wrapper = doc2.querySelector('.shopify-section');
      if (wrapper) bubble.innerHTML = wrapper.innerHTML;
    }
    var d = drawer();
    if (d) { d.classList.remove('is-empty'); }
    if (thenOpen) uv6Open();
  }
  window.uv6AddToCart = function (form, btn) {
    if (btn) btn.disabled = true;
    fetch(window.uv6Routes.cart_add_url, { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
      .then(function (res) { if (!res.ok) { throw new Error((res.data && res.data.description) || 'add-error'); } return uv6FetchSections(); })
      .then(function (sections) { uv6RenderSections(sections, true); })
      .catch(function () { window.location.href = window.uv6Routes.cart_url; })
      .finally(function () { if (btn) btn.disabled = false; });
  };
  function uv6ChangeLine(index, quantity) {
    fetch(window.uv6Routes.cart_change_url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: index, quantity: quantity }) })
      .then(function () { return uv6FetchSections(); })
      .then(function (sections) { uv6RenderSections(sections, true); });
  }
  function uv6BindCartIcon() {
    var bubble = document.getElementById('cart-icon-bubble');
    var link = bubble ? bubble.closest('a') : null;
    if (link && !link.dataset.uv6Bound) { link.dataset.uv6Bound = '1'; link.addEventListener('click', function (e) { e.preventDefault(); uv6Open(); }); }
  }
  document.addEventListener('click', function (e) {
    var qbtn = e.target.closest('cart-drawer .quantity__button');
    if (qbtn) { e.preventDefault(); var wrap = qbtn.closest('.quantity') || qbtn.parentElement; var input = wrap ? wrap.querySelector('.quantity__input') : null; if (!input) return; var index = input.dataset.index; var val = parseInt(input.value, 10) || 0; var next = qbtn.name === 'plus' ? val + 1 : Math.max(0, val - 1); uv6ChangeLine(index, next); return; }
    var removeBtn = e.target.closest('cart-drawer cart-remove-button');
    if (removeBtn) { e.preventDefault(); var idx = removeBtn.dataset.index; if (idx) uv6ChangeLine(idx, 0); return; }
    if (e.target.id === 'CartDrawer-Overlay') { uv6Close(); return; }
    var closeBtn = e.target.closest('.drawer__close');
    if (closeBtn && closeBtn.closest('cart-drawer')) { e.preventDefault(); uv6Close(); return; }
  });
  document.addEventListener('keyup', function (e) { if (e.code === 'Escape') uv6Close(); });
  window.handleDiscountForm = function (e) {
    e.preventDefault();
    var input = e.target.querySelector('[name="cart-discount-field"]');
    var errorEl = e.target.querySelector('.cart-discount-form__error');
    var code = input ? input.value : '';
    if (!code || !code.length) { if (errorEl) errorEl.style.display = 'block'; return; }
    if (errorEl) errorEl.style.display = 'none';
    window.location.href = '/checkout?discount=' + encodeURIComponent(code);
  };
  window.handleDiscountFormChange = function () { document.querySelectorAll('.cart-discount-form__error').forEach(function (el) { el.style.display = 'none'; }); };
  function uv6BindMenuDrawer() {
    document.querySelectorAll('details').forEach(function (d) {
      if (d.dataset.uv6ToggleBound) return;
      d.dataset.uv6ToggleBound = '1';
      d.addEventListener('toggle', function () {
        d.classList.toggle('menu-opening', d.open);
        if (d.id === 'Details-menu-drawer-container') {
          document.body.classList.toggle('overflow-hidden', d.open);
        }
      });
    });
  }

  document.addEventListener('click', function (e) {
    var closeBtn = e.target.closest('.menu-drawer__close-btn, .menu-drawer__close-menu-btn');
    if (closeBtn) {
      var details = closeBtn.closest('details');
      if (details) details.open = false;
    }
  });

  document.addEventListener('keyup', function (e) {
    if (e.code === 'Escape') {
      var openDetails = document.getElementById('Details-menu-drawer-container');
      if (openDetails && openDetails.open) openDetails.open = false;
    }
  });

  function uv6Init() { uv6BindCartIcon(); uv6BindMenuDrawer(); }
  document.addEventListener('DOMContentLoaded', uv6Init);
  if (document.readyState !== 'loading') uv6Init();
})();
